export default "__VITE_ASSET__6b1cd766__"